import { RootState } from 'store/store';

export const selectCurrencyData = (state: RootState) => state.currency.currency;
export const selectCurrencyRequestStatus = (state: RootState) => state.currency.currencyRequestStatus;
